<template>
    <basic-card>
        <template slot="header">
            {{$t('administration.securityGroups')}}<context-help help-item-code="security-groups-view"/>
        </template>
        <simple-layout horizontal>
            <data-table
                    :configuration="securityGroupsTableConfig"
                    :data="securityGroups"
                    component-id="security-group-table"
                    @focusedChanged="handleFocusChanged"
                    @add="handleAdd"
            >
                <basic-card v-if="focusedGroup != null">
                    <form-wrapper :form-title="`${$t('administrations.securityGroups')}`">
                        <form-text-input v-model="focusedGroup.id" caption="Id" disabled/>
                        <form-text-input v-model="focusedGroup.name" :caption="`${$t('name')}`"/>
                        <form-text-input v-model="focusedGroup.description" :caption="`${$t('description')}`"/>
                    </form-wrapper>
                    <simple-button @press="save">{{$t("save")}}</simple-button>
                </basic-card>
            </data-table>
        </simple-layout>
    </basic-card>
</template>

<script>
    import SimpleLayout from "../components/layout/SimpleLayout";
    import DataTable from "../components/table/DataTable";
    import BasicCard from "../components/layout/BasicCard";
    import FormWrapper from "../components/form/FormWrapper";
    import FormTextInput from "../components/form/FormTextInput";
    import SimpleButton from "../components/button/SimpleButton";
    import {mapGetters} from "vuex";
    import ContextHelp from "../components/help/ContextHelp";

    export default {
        name: "SecurityGroupsView",
        components: {ContextHelp, SimpleButton, FormTextInput, FormWrapper, BasicCard, DataTable, SimpleLayout},
        data: function () {
            return {
                focusedGroup: null,
                securityGroupsTableConfig: {
                    objectName: this.$t('securityGroup.objectName'),
                    enableAdd: true,
                    allowEdit: true,
                    columns: [
                        {
                            caption: "Id",
                            datum: d => d.id
                        },
                        {
                            caption: this.$t('name'),
                            datum: d => d.name
                        },
                        {
                            caption: this.$t('description'),
                            datum: d => d.description
                        }
                    ]
                }
            }
        },
        methods: {
            handleAdd() {
                this.focusedGroup = {};
            },
            handleFocusChanged(focusedGroup) {
                this.focusedGroup = focusedGroup;
            },
            save() {
                this.$store.dispatch("securityGroups/saveSecurityGroup", this.focusedGroup).then(() => {
                    this.focusedGroup = null;
                    this.$store.dispatch("securityGroups/refreshSecurityGroups");
                });
            }
        },
        computed: {
            ... mapGetters({
                "securityGroups": "securityGroups/securityGroups"
            })
        },
        mounted() {
            this.$store.dispatch("securityGroups/refreshSecurityGroups");
        }
    }
</script>

<style scoped>

</style>